import { combineReducers } from '@reduxjs/toolkit';
import { all, fork } from 'redux-saga/effects';
import accordionStepsSaga from './accordion.saga';
import accordionstepsSlice from './accordion.slice';
import accountSaga from './account.saga';
import accountSlice from './account.slice';
import ordersSaga from './orders.saga';
import ordersSlice from './orders.slice';
import userInfoSaga from './userInfo.saga';
import userInfoSlice from './userInfo.slice';
export const accountRootReducer = combineReducers({
    account: accountSlice.reducer,
    orders: ordersSlice.reducer,
    step: accordionstepsSlice.reducer,
    userInfo: userInfoSlice.reducer,
});
export function* accountRootSaga() {
    yield all([fork(accountSaga), fork(ordersSaga), fork(accordionStepsSaga), fork(userInfoSaga)]);
}
